import React, { Fragment } from 'react'
import { useCallback, useEffect } from 'sb-hooks'
import { constants, links, mixpanel } from 'common/helpers'
import actions from 'redux/actions'

import Overlay from 'components/_new/layout/Overlay/Overlay'
import ModalContainer from 'components/_new/modal/ModalContainer/ModalContainer'
import Modal from 'components/_new/modal/Modal/Modal'
import Box from 'components/_new/layout/Box/Box'
import Title from 'components/_new/typography/deprecated/Title/Title'
import Text from 'components/_new/typography/Text/Text'
import Button from 'components/_new/Button/Button'

import s from './SkincareWellnessModal.scss'
import messages from './messages'


const close = () => {
  actions.models.modals.close(constants.modals.newProducts.SkincareWellness)
  actions.models.ui.setClosedPopup(constants.modals.newProducts.SkincareWellness)
}

const SkincareWellnessModal = () => {
  const onClick = useCallback(() => {
    mixpanel.track(constants.analyticsEvents.popupWellnessClick)
    close()
  }, [])

  useEffect(() => {
    mixpanel.track(constants.analyticsEvents.popupWellness)
  }, [])

  return (
    <Fragment>
      <ModalContainer>
        <Overlay onClick={close} />
        <Modal className={s.modal} onClose={close}>
          <Text message={messages.supTitle} size="14-24" html />
          <Title className={s.title} message={messages.title} size="lg" />
          <Text className={s.text} message={messages.text} html />
          <Box mt="36">
            <Button
              title={messages.buttonTitle}
              size="md"
              color="brand"
              uppercase
              to={links.skincareWellness}
              onClick={onClick}
            />
          </Box>
        </Modal>
      </ModalContainer>
    </Fragment>
  )
}


export default SkincareWellnessModal
